import { gql } from '@apollo/client';
import FULL_JOB_MATCH_FRAGMENT from 'graphql/fragments/companyUser/jobMatchFragment';

export default gql`
  ${FULL_JOB_MATCH_FRAGMENT}
  fragment FullJob on Job {
    id
    stream_chat_subject_id
    name
    country
    city
    propose_to_matchers
    is_draft
    is_remote_an_option
    link_to_details
    office_hours_per_month
    skills {
      id
      name
      skill_type
      job_skill_pivot {
        is_required
      }
    }
    skills_boolean_filter {
      not_skills {
        id
        name
        skill_type
      }
      boolean_skills_filter_items {
        one_of_skills {
          id
          name
          skill_type
        }
        all_of_skills {
          id
          name
          skill_type
        }
        boolean_operator
      }
    }
    category {
      id
      name
    }
    subcategory {
      id
      name
    }
    description
    pitch
    start_date
    end_date
    rate_min
    rate_max
    is_rate_negotiable
    campaign_owner {
      id
      first_name
      last_name
      email
      company {
        name
        id
      }
    }
    invitations {
      id
      talent_id
    }
    campaign_start_date
    campaign_end_date
    campaign_talent_pool
    is_archived
    matches {
      ...FullJobMatch
    }
    matches_count
    instant_matches_count
    matches_with_application_count
    salary_max
    salary_min
    finders_fee
    saved_matches {
      created_at
      id
      talent {
        first_name_abac {
          value
        }
        last_name_abac {
          value
        }
        id
        email_abac {
          value
        }
        currency
        address
        recent_position_title
        location
        rate_max
        rate_min
        is_invitation_accepted
      }
      matched_skills {
        id
        name
        skill_type
      }
      match_percent
      match_type
    }
    location
    hours_per_week
    location_type
    type
    period
    client
    capacity
    posted_at
    job_source_type
    striive_job {
      segment_name
      segment_name_slug
      id
      striive_id
      status
      title
      content
      hours_per_week_min
      hours_per_week_max
      start_date
      end_date
      location
      location_slug
      permanent_job
      client_id
      client_name
      client_name_slug
      recruiter_slug
      number_of_positions
      recruiter_first_name
      recruiter_last_name
      recruiter_middle_name
      hourly_rate_client
      rate_type
      monthly_rate_min
      monthly_rate_max
      hourly_rate_min
      hourly_rate_max
      attachments
      auto_invoice_type
      billable_per_diem
      broker
      broker_slug
      broker_url
      business_unit
      can_submit_job_seeker
      closed_reason_name
      closing_date_client
      closing_date_invoice
      comments
      coordinator_full_name
      coordinator_legal_name
      cost_center_record_id
      cover_image_url
      created_at
      department
      department_allocation
      department_code
      department_slug
      distributor_full_name
      distributor_legal_name
      entity
      estimated_additional_spend
      estimated_expenses
      estimated_total_hours
      extendable
      external_created_at
      external_request_number
      has_client_logo
      has_max_rate
      has_recruiter_image
      hours_per_day
      is_archived
      job_status
      job_type
      language_code
      max_submissions_allowed
      maximum_expenses
      order_classification_status
      order_classification_type
      order_contact_full_name
      order_contact_legal_name
      order_contact_type
      portal_id
      position_rule_allow_supplier_to_select_job_seeker_site
      position_rule_auto_activate
      position_rule_auto_engage
      position_rule_auto_register
      position_rule_bill_rate_can_exceed_requested
      position_rule_pay_rate_required
      position_rule_resume_required
      position_rule_supplier_must_enter_rate_change_amounts
      published_date
      purchase_order_number
      qualifications
      questions
      rates
      record_id
      recruiter
      recruiter_email
      recruiter_function_title
      recruiter_id
      recruiter_initials
      recruiter_phone_number
      reference_code
      reference_code_client
      report_to_full_name
      report_to_legal_name
      service_type
      site_tax
      source
      staffing_customer_record_id
      staffing_supplier_record_id
      submitted_at
      tag_names
      tags
      title_slug
      trail_end_date
      travel_time
      updated_at
      work_site_address
      work_site_address2
      work_site_city
      work_site_country_code
      work_site_postal_code
      work_site_record_id
      work_site_state_code
    }
  }
`;
